export const INS_FULL_FORMAT_REGEX = /^[1234789]\d{4}(?:\d{5}|2[AB]\d{3})\d{5}$/i

const INS_NIR_LENGTH = 13
const INS_CONTROL_KEY_MODULUS = 97

export function sanitizeInsSearchValue(value: string): string {
  return value.replace(/\D/g, '')
}

export function hasValidInsFormat(ins: string): boolean {
  return INS_FULL_FORMAT_REGEX.test(ins.trim())
}

export function hasValidInsControlKey(ins: string): boolean {
  const formattedIns = ins.trim().toUpperCase()
  if (!hasValidInsFormat(formattedIns)) return false

  const nir = Number(formattedIns.slice(0, INS_NIR_LENGTH).replace('2A', '19').replace('2B', '18'))
  const key = Number(formattedIns.slice(INS_NIR_LENGTH))
  const expectedKey = INS_CONTROL_KEY_MODULUS - (nir % INS_CONTROL_KEY_MODULUS)
  return key === expectedKey
}

export function splitInsNir(ins: string): { value: string; key: string } {
  const formattedIns = ins.trim().toUpperCase()
  return {
    value: formattedIns.slice(0, INS_NIR_LENGTH),
    key: formattedIns.slice(INS_NIR_LENGTH),
  }
}

export function isNumericSearch(value: string): boolean {
  return /^[\d\s]+$/.test(value.trim())
}
